import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import { inject, observer, setDocumentTitle, setUidToken, getlang, setlang } from 'src/helper/devTools.js'
import http from 'src/helper/http'
import Toast from '../../../component/Toast'
import { history } from 'src/core/router'
import { jumpToUser, setTabBar, getDeviceInfo } from 'src/helper/webviewFun.js'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
    setDocumentTitle('AgentRecharge')
  }

  state = {
    uid: 0,
    lang: langM.ar,
    language: 'en',
    setSeachValue: '',
    showEmpty: false,
    seachList: [],
    hostMemberList: [],
    guild_id: '',
    scroll: '0,20',
    hedinTabar: false,
    hostMenber: 0,
    hasMore:false,
    admin_uid:'',
    showRemoveToast:false,
    wantDelItem:{},
    toastContent:'',
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en/tr)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    let guiId = this.props.location.query.guid * 1
    if (guiId) {
      this.setState({ guild_id: guiId })
      this.getMemberList(guiId)
      this.getTiInfo(guiId)
    }
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })
    try {
      let res = await getDeviceInfo()
    setTabBar('2')
    if (res.res.os) {
      let getVersionFrist = res.res.version.split('.')
      console.log('getVersionFrist',getVersionFrist)
      if (getVersionFrist[0] >= 4 && getVersionFrist[1] >= 1) {
        this.setState({ hedinTabar: true })
      }
    }
    } catch (error) {
      
    }
    this.getTiInfo()
  }

  getTiInfo = async (guild_id) => {
    let res = await http.post('/web/guild/info', { guild_id })
    guild_id == 0 && this.refs.msg.show(`Due to the system upgrade, the union information did not exist`)
    if (res.code == 0) {
      this.setState({ hostMenber: res.res.member_number, admin_uid:res.res.admin_uid })
    }
  }

  getMemberList = async (id) => {
    let { scroll, guild_id, hostMemberList, setSeachValue } = this.state
    let res = await http.post('/web/guild/member', { scroll: '0', guild_id: id || guild_id, kw: setSeachValue })
    if (res.code == 0) {
      this.setState({
        scroll: res.res.scroll,
        hasMore: res.res.has_more,
        hostMemberList: [...res.res.list]
      })
    }
  }

  componentDidMount() {}

  fonsue = (e) => {
    let { setSeachValue } = this.state
    this.setState({ showEmpty: e })
  }

  getLvBg = (e)=>{
    let srt = ''
    if (e == 0) {
       srt = '0'
    }else if (e >0 && e<=9) {
      srt = '09'
    }else if (e >9 && e<=19) {
      srt = '1019'
    }else if (e >19 && e<=29) {
      srt = '2029'
    }else if (e >29 && e<=39) {
      srt = '3039'
    }else if (e >39 && e<=49) {
      srt = '4049'
    }else if (e >49 && e<=59) {
      srt = '5059'
    }else if (e >59 && e<=69) {
      srt = '6069'
    }else if (e >69 && e<=79) {
      srt = '7079'
    }else if (e >79 && e<=89) {
      srt = '8089'
    }else if (e >89 && e<=99) {
      srt = '9099'
    }else if (e == 100) {
      srt = '100'
    }
    return srt
  }

  setSeachValueFn = async (e) => {
    this.seachItemId && clearTimeout(this.seachItemId)
    await this.setState({ setSeachValue: e.target.value })
    /* this.seachItemId = setTimeout(() => {
      this.getMemberList()
    }, 500) */
  }

  handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target
    let { hasMore } = this.state
    if (scrollTop + clientHeight + 30 >= scrollHeight) {
      if (hasMore) return this.addRankingList()
    }
  }
  handleSearchFn = () => {
    this.setState({})
    this.getMemberList()
  }

  handleClearSearchFn = async () => {
    await this.setState({ setSeachValue: '' })
    document.querySelector('.getvluaeinput').value = ''
    this.getMemberList()
  }

  addRankingList = async () => {
    let { scroll, guild_id, hostMemberList, setSeachValue } = this.state
    let res = await http.post('/web/guild/member', { scroll, guild_id, kw: setSeachValue })
    if (res.code == 0) {
      this.setState({
        hostMemberList: res.res.list.length>0 && [...hostMemberList, ...res.res.list],
        scroll: res.res.scroll,
        hasMore: res.res.has_more
      })
    }
  }
  
  removeHost = async(e)=>{
    let { wantDelItem, lang, admin_uid, uid } = this.state
    if (admin_uid != admin_uid) {
      this.setState({toastContent:lang.remove_toast1, showRemoveToast:false})
      this.refs.toast.hideRule(true)
      return
    }
    let res = await http.post('/web/guild/member/remove',{uid:wantDelItem.uid})
    if (res.code == 0) {
      await this.setState({toastContent:lang.remove_toast2, showRemoveToast:false})
      this.refs.toast.hideRule(true)
      this.getMemberList()
    }else if (res.code && res.code !=0) {
      if (res.code == 1) {
        await this.setState({toastContent:lang.remove_toast1, showRemoveToast:false})
        this.refs.toast.hideRule(true)
      }else{
        await this.setState({toastContent:res.msg, showRemoveToast:false})
        this.refs.toast.hideRule(true)
      }
      
    }else{
      this.setState({toastContent:`${lang.remove_toast3} erro `, showRemoveToast:false})
    }
  }
  render() {
    let {  toastContent , showRemoveToast, admin_uid, uid, hedinTabar, wantDelItem, showEmpty, setSeachValue, seachList, hostMenber, hostMemberList, lang, language } = this.state
    return (
      <div className={`host-member  ${language == 'ar' && 'arlang'}`} >
        <div className="nav-top-root">
          { <div style={{ width: '6rem', height: '0.44rem' }}></div>}
          <div className="nav-top">
            <img
              className="close-view"
              style={{ transform: `${language == 'ar' ? 'rotate(180deg)' : ''}` }}
              src="img/app/newhost/colse_cb.png"
              onClick={() => history.go(-1)}
            ></img>
            <div className="title-name">{lang.isSend(hostMenber)}</div>
          </div>
          <div className="seach-root">
            <div className="input-root">
              {!showEmpty && setSeachValue.length == 0 && (
                <div className="value-empty">
                  <img
                    className="seach-icon"
                    style={{ marginLeft: `${language == 'ar' ? '0.2rem' : ''}` }}
                    src="img/app/newhost/seach_icon.png"
                  ></img>
                  <div className="text-inrle">{lang.searchPolad}</div>
                </div>
              )}
              {
                <input
                  className="getvluaeinput"
                  onClick={() => this.fonsue(true)}
                  onBlur={() => this.fonsue(false)}
                  onChange={(e)=>this.setSeachValueFn(e)}
                ></input>
              }
            </div>
            {
              <div
                className="search-btn"
                onClick={this.handleSearchFn}
                style={{ color: `${setSeachValue.length == 0 ? '' : '#A47D1C'}` }}
              >
                {lang.searchText}
              </div>
            }
            {false && setSeachValue.length > 0 && (
              <div
                className="search-btn"
                onClick={this.handleClearSearchFn}
                style={{ color: `${setSeachValue.length == 0 ? '' : '#A47D1C'}` }}
              >
                {'Cancel'}
              </div>
            )}
          </div>
        </div>
        <div style={{ height: '2.8rem', width: '5.5rem' }}></div>
        {hostMemberList.length > 0 && (
          <div className="seach-list" onScroll={(e) => this.handleScroll(e)} >
            {hostMemberList.map((item, index) => (
              <div className="list-item" key={index}>
                <div className="item-avt">
                  <img className="img-avt" src={item.avatarurl} onClick={() => jumpToUser(item.uid)} />
                  {item.online && <div className="in-line"></div>}
                </div>
                <div className="item-info">
                  <div className="name-madal">
                    <div className="name-text">{item.nickname}</div>
                    {item.gender && item.gender > 0 && (
                      <img
                        className="sex-man"
                        src={item.gender == 2 ? '/img/app/newhost/woman_icon.png' : '/img/app/newhost/boy_icon.png'}
                      />
                    )}
                    <img src={item.countryIcon} className="user-ctry-icon"></img>
                  </div>
                  <div className="id-time">
                    <div>ID: {item.duid} </div>
                  </div>
                  {admin_uid != item.uid && <div className='remove-btn' onClick={()=>this.setState({showRemoveToast:true,wantDelItem:item})} style={{[language=='ar'?'left':'right']:'0'}}>{lang.removeText}</div>}
                </div>
              </div>
            ))}
          </div>
        )}
        {setSeachValue.length > 0 && hostMemberList.length == 0 && (
          <div className="empty-root">
            <img className="empty-root-img" src="img/app/newhost/empty_img.png"></img>
            <div className="empty-text">{this.state.lang.searchEmptyTrxt}</div>
          </div>
        )}
        {showRemoveToast  &&<div className='remove-root' onClick={()=>{this.setState({showRemoveToast:false}); e.stopPropagation()}}>
           <div className='handle-root'>
             <div className='tips'>{lang.tips}</div>
             <div className='context'>{lang.remove(wantDelItem.nickname,wantDelItem.duid)}</div>
             <div className='btn-root'>
               <div className='cel-btn' onClick={()=>this.setState({showRemoveToast:false})}>{lang.cancel}</div>
               <div className='cof-btn' onClick={()=>this.removeHost(wantDelItem.uid)}>{lang.confirm}</div>
             </div>
           </div>
        </div>}
        <Toast language={language} lang={lang} ref="toast" id="toast" toastContent={toastContent} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/host-member/index.js